module.exports = __webpack_public_path__ + "img/group2Img.8a256aa9.png";